module.exports = __webpack_public_path__ + "img/logo@3x.58278c73.png";